import http from "@/http";
//###  会员列表
//  https://zs.xzu.ink/api/member/list
export const getMemberList = {
  p: "/api/member/list",
  r: data => {
    return http({
      url: "/api/member/list",
      method: "post",
      data
    });
  }
};
//### 修改会员信息
// https://zs.xzu.ink/api/member/edit
export const editMember = {
  p: "/api/member/edit",
  r: data => {
    return http({
      url: "/api/member/edit",
      method: "post",
      data
    });
  }
};
//### 删除会员
// https://zs.xzu.ink/api/member/delete
export const deleteMember = {
  p: "/api/member/delete",
  r: data => {
    return http({
      url: "/api/member/delete",
      method: "post",
      data
    });
  }
};
//### 获取会员详细信息
// https://zs.xzu.ink/api/member/details/1
export const getMemberInfo = {
  p: "/api/member/details",
  r: data => {
    return http({
      url: "/api/member/details/" + data.id,
      method: "get"
      // data
    });
  }
};
//###    二维码地址
// api/member/share_qr/用户id
export const getMemberShareQr = {
  p: "api/member/share_qr",
  r: data => {
    return http({
      url: "api/member/share_qr/" + data.id,
      method: "get"
      // data
    });
  }
};
